






























import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Button from './Button.vue';
import ChatMessage from './ChatMessage.vue';
import SockController, { SOCK_ACTIONS } from '../controller/SockController';
import SocketEvent from '../vo/SocketEvent';
import UserData from '../vo/UserData';
import Config from '../utils/Config';
import FormView from './FormView.vue';
import CurrentGoal from './CurrentGoal.vue';
import AskInfo from './AskInfo.vue';

@Component({
	components:{
		Button,
		AskInfo,
		FormView,
		CurrentGoal,
		ChatMessage
	}
})
export default class ChatView extends Vue {

	private showForm:boolean = false;
	private showAsk:boolean = false;
	private showSend:boolean = false;

	public ELEMENTS:string[] = Config.ELEMENTS;

	public get users():UserData[] {
		let users:UserData[] = this.$store.state.room.users
		users.sort((a,b)=> {
			if(a.index < b.index) return -1;
			if(a.index > b.index) return 1;
			return 0;
		})
		return users;
	}

	public get messageList():any[] {
		return this.$store.state.chatMessages;
	}

	public mounted():void {
	}

	public beforeDestroy():void {
	}

	@Watch("$store.state.chatMessages")
	public async onMessage(event:SocketEvent):Promise<void> {
		await this.$nextTick();
			this.scrollToBottom()
		setTimeout(_=> {
			this.scrollToBottom()
		},30)

	}

	private scrollToBottom():void {
		let div = <HTMLDivElement>this.$refs.messageList;
		div.scrollTop = div.scrollHeight;
	}

	public sendInfos():void {
		this.showForm = true;
		this.showSend = true;
	}

	public askInfo():void {
		this.showForm = true;
		this.showAsk = true;
	}

	public closeForm():void {
		this.showForm = false;
		this.showAsk = false;
		this.showSend =false;
	}

}
